module.exports = __webpack_public_path__ + "static/cryptovoxels-f35ff04f08aa38509418876718eb83b3.gif";